<template>
	<v-app-bar id="default-app-bar" app absolute class="v-bar--underline" color="transparent" :clipped-left="$vuetify.rtl" :clipped-right="!$vuetify.rtl" height="70" flat>
		<v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" />

		<default-drawer-toggle class="hidden-sm-and-down" />

		<default-settings />

		<v-spacer />

		<!-- <default-search class="hidden-sm-and-down" /> -->

		<default-notifications />

		<default-account @profile="profile" />

		<v-dialog v-model="dialogUser" scrollable persistent max-width="900px">
			<v-card>
				<v-card-title>
					<span class="headline">مشخصات کاربر</span>
					<v-spacer />
					<v-btn @click="dialogUser = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-profile ref="modifyProfile" :data="selectedUser" @callbck="callbck_userprofile" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-app-bar>
</template>

<script>
	// Utilities
	import { get, sync } from 'vuex-pathify'
	import ModifyProfile from '@/views/member/ModifyProfile.vue'

	export default {
		name: 'DefaultBar',

		components: {
			DefaultAccount: () => import(
				/* webpackChunkName: "default-account" */
				'./widgets/Account'
			),
			DefaultDrawerToggle: () => import(
				/* webpackChunkName: "default-drawer-toggle" */
				'./widgets/DrawerToggle'
			),
			DefaultNotifications: () => import(
				/* webpackChunkName: "default-notifications" */
				'./widgets/Notifications'
			),
			DefaultSearch: () => import(
				/* webpackChunkName: "default-search" */
				'./widgets/Search'
			),
			DefaultSettings: () => import(
				/* webpackChunkName: "default-settings" */
				'./Settings'
			),
			'modify-profile': ModifyProfile,
		},
		data() {
			return {
				selectedUser: {},
				dialogUser: false,
			}
		},

		computed: {
			...sync('app', [
				'drawer',
				'mini',
			]),
			name: get('route/name'),
			getCurrentUser: get('auth/getCurrentUser'),
		},
		methods: {
			profile() {
				var user = this.getCurrentUser
				if (!user || !user.userData) { return }
				this.selectedUser = { id: user.userData.id }
				this.dialogUser = true
				this.$nextTick(() => {
					this.$refs.modifyProfile.prepareData()
				})
			},
			callbck_userprofile(result) {
				this.dialogUser = false
			},
		},
	}
</script>
